var exports = {
  "Pf": "xfb577c5e--a3d989--label",
  "wm": "xfb577c5e--a3d989--logo",
  "_8": "xfb577c5e--a3d989--img",
};

module.exports = exports;
